export default __webpack_public_path__ + "static/media/keto-bars-box@2x.e2cd8af3.png";